import { animated } from '@react-spring/web';
import styled from 'styled-components';

export const CoLocatedStickyMenuWrapper = styled.div<{ showList: boolean }>`
  display: flex;
  align-items: center;
  overflow: hidden; /* hide sliding content */
  gap: 0;

  position: fixed;
  top: 50%;
  right: 0;
  transform: translateY(-50%);

  background-color: ${({ theme }) => theme.color.mobilityGrey};
  border-top-left-radius: ${({ theme }) => theme.borderRadius.radius10};
  border-bottom-left-radius: ${({ theme }) => theme.borderRadius.radius10};

  color: ${({ theme }) => theme.color.white};
  z-index: 3;

  width: ${({ showList }) => (showList ? '220px' : '45px')};
  transition:
    width 0.4s ease-in-out,
    background-color 0.3s ease-in-out;
`;

export const RotatedMenu = styled.div`
  display: flex;
  flex-direction: row;
  align-items: center;
  justify-content: center;
  gap: 0.5rem;

  cursor: pointer;
  writing-mode: vertical-lr;
  transform: rotate(360deg);
  padding: 2.3rem 1rem;
`;

export const MenuTitle = styled.span`
  color: ${({ theme }) => theme.color.white};
  font-weight: ${({ theme }) => theme.fontWeight.weight500};
  line-height: ${({ theme }) => theme.lineHeight.height150};
  font-size: ${({ theme }) => theme.fontSize.size20};
  margin-bottom: 0.5rem;
`;

export const LogoListWrapper = styled.div<{ showList: boolean }>`
  display: flex;
  flex-direction: column;
  align-items: center;
  justify-content: center;
  gap: 1rem;

  height: -webkit-fill-available;
  min-height: 25.313rem;
  min-width: 160px;

  flex: 1;

  background-color: ${({ theme }) => theme.color.white};
  opacity: ${({ showList }) => (showList ? 1 : 0)};
  transform: ${({ showList }) =>
    showList ? 'translateX(0)' : 'translateX(100%)'};
  transition:
    transform 0.4s ease-in-out,
    opacity 0.4s ease-in-out;
`;

export const LogoWrapper = styled.div`
  display: flex;
  justify-content: flex-start;
  align-items: center;

  width: 100%;
  height: 50px;

  cursor: pointer;
  padding: 0.3rem;
  transition: transform 0.25s ease-in-out;

  &:hover {
    transform: scale(0.95);
  }
`;

export const LogoImage = styled.img`
  height: auto;
  max-height: 50px;
  width: fit-content;
  object-fit: contain;

  transition:
    transform 0.25s ease-in-out,
    filter 0.25s ease-in-out;

  ${LogoWrapper}:hover & {
    transform: scale(0.9);
    filter: brightness(0.9);
  }
`;

export const RotateIcon = styled(animated.div)`
  position: relative;
  top: 0.2rem;
`;
